import { render } from "./DefaultPage.vue?vue&type=template&id=72965284"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__